export default "__VITE_ASSET__58867e03__"